import TmrBaseResource from './TmrBaseResource'

export default class Places extends TmrBaseResource {
  static endpoint = '/places'
}
